import { render, staticRenderFns } from "./profileStu.vue?vue&type=template&id=0dc75739&scoped=true&"
import script from "./profileStu.vue?vue&type=script&lang=js&"
export * from "./profileStu.vue?vue&type=script&lang=js&"
import style0 from "./profileStu.vue?vue&type=style&index=0&id=0dc75739&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc75739",
  null
  
)

export default component.exports